/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { AiType as AiTypeUnion } from '@squiz/dxp-ai-client';
import { AiType } from '@squiz/dxp-ai-types';
export const isGenerative = (type: AiTypeUnion): boolean => {
  return type === AiType.generative;
};
